import React from 'react';
import { WaterPrediction } from '@/components/predictions/WaterPrediction';
import { WeatherAnalysis } from '@/components/WeatherAnalysis';
import useTranslation from '@/hooks/use-translation';
import { useMode } from '@/contexts/ModeContext';

const Predictions = () => {
  const { translate } = useTranslation();
  const { mode } = useMode();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">
          {translate("Predictions & Forecasts")}
        </h1>
        <p className="text-muted-foreground">
          {translate(
            mode === 'household'
              ? "Smart predictions to help you optimize your household water consumption"
              : "Advanced forecasting to improve your irrigation efficiency"
          )}
        </p>
      </div>

      <div className="grid gap-6">
        <WaterPrediction />
        <WeatherAnalysis />
      </div>
    </div>
  );
};

export default Predictions; 